import { render, staticRenderFns } from "./Pos.vue?vue&type=template&id=b2420a5e&scoped=true&"
import script from "./Pos.vue?vue&type=script&lang=js&"
export * from "./Pos.vue?vue&type=script&lang=js&"
import style0 from "./Pos.vue?vue&type=style&index=0&id=b2420a5e&scoped=true&lang=css&"
import style1 from "./Pos.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2420a5e",
  null
  
)

export default component.exports